





































import { Component, Mixins } from 'vue-property-decorator';
import Counter from '@rogues/Counter/shared/counter';
import moment from 'moment-timezone';
import VueCountdown from '@chenfengyuan/vue-countdown';

@Component({
    components: {
        VueCountdown,
    },
})

/**
 * @name Simple
 */
export default class Simple extends Mixins(Counter) {
    // Grab the current date
    currentDate = new Date();

    // Target future date/24 hour time/Timezone
    targetDate: any = moment.tz(moment(this.getValue('targetTime'), 'X'), this.getValue('timezone'));

    // Calculate the difference in seconds between the future and current date
    diff = this.targetDate - this.currentDate.getTime();

    /**
     * Languages trans
     */
    langs = {
        days   : this.$t('lang.days'),
        hours  : this.$t('lang.hours'),
        minutes: this.$t('lang.minutes'),
        seconds: this.$t('lang.seconds'),
    }
}
